import { render, staticRenderFns } from "./WechatPublicEdit.vue?vue&type=template&id=6fcbf408&"
import script from "./WechatPublicEdit.vue?vue&type=script&lang=js&"
export * from "./WechatPublicEdit.vue?vue&type=script&lang=js&"
import style0 from "./WechatPublicEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports